import {LeaderboardUser} from '@dms/api/settings';

/** Client-side page slice (1-based page index). */
export const paginateLeaderboardUsers = (
  users: LeaderboardUser[],
  page: number,
  rowsPerPage: number
): LeaderboardUser[] => {
  const start = (page - 1) * rowsPerPage;

  return users.slice(start, start + rowsPerPage);
};

/** Total number of pages for the given row count (at least 1). */
export const getLeaderboardPageCount = (totalRows: number, rowsPerPage: number): number =>
  Math.max(1, Math.ceil(totalRows / rowsPerPage));
